exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".plan-text-wrap[data-v-7cedcf56]{display:inline-block;word-break:break-all;white-space:pre-line}", ""]);
